import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * カナチェッククラス
 */
export default class EFOcats_validate_kana extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    if (!checkData.val().match(/^[ァ-ヶー]+$/)) {
      result = new EFOcats_error_info('error', 'カタカナのみで入力してください。', '', 'カタカナのみで入力してください。');
    }

    return result;
  }
}
